import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import {baseUrl } from "../../comman/config";
import { useLocation } from 'react-router-dom';
import { menuAboveTable } from "../../comman/selectMenu";

const EventDateSessionFilter = ({ handleFilterChange }) => {
    const today = new Date().toISOString().split('T')[0];
    const [event, setEvent] = useState({});
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const [session, setSession] = useState([]);
    const [method, setMethod] = useState([]);
    const [filter, setFilter] = useState(false)

    const [sessionList, setSessionList] = useState([]);
    const [methodList, setMethodList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const location = useLocation();
    const routeName = location.pathname

    useEffect(() => {
        getEventList()
        getSessionList();
        getMethodList()
    }, []);

    const getEventList = async() => {
        const response = await axios.get(`${baseUrl}/comman/list?table=event_master&condition=status=1`);
        const data = response.data.data;
        const newObject = { id: 'all', event_name: 'All' };
        data.unshift(newObject);
        setEventList(data);
        setEvent({ value: 'all', label: 'All' })
    }

    const getSessionList =  async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=session_master&condition=status=1`,
            { headers: { 'Cache-Control': 'no-cache' } }
        );
        setSessionList(response.data.data);
    }

    const getMethodList = async () => {
        const response = await axios.get(
          `${baseUrl}/comman/list?table=method_master&condition=status=1`
        );
        setMethodList(response.data.data);
      };

    // Changing From Date carries To Date with it. Most of this filter's use is a single day, and
    // leaving To Date behind silently reported a range nobody asked for -- worse, an earlier To
    // Date than From gives an empty result that reads as "no data" rather than "bad range".
    // To Date is still free: set it after and it keeps whatever you gave it.
    const handleDateChange = (e) => {
        const {name, value} = e.target;
        if(name == "from_date"){
            setFromDate(value);
            setToDate(value);
        }else if(name == "to_date"){
            setToDate(value);
        }
        
    };
    // const handleDateChange = (e) => {
    //     setDate(e.target.value);
    // };

    const isSingleSessionRoute = routeName === "/raw_material_estimation/list" || routeName === "/raw_material_recipe/list";

    const handleSelectChange = (data, option) => {
        // For single-select routes, wrap in array to keep session[0].value usage consistent
        if (isSingleSessionRoute) {
            setSession(data ? [data] : []);
        } else {
            setSession(data);
        }
    };

    const handleChangeMultiSelect = (selected, name) => {
        if(name === 'method'){
            setMethod(selected);
        }
    };

    const handelEventChange = (item) => {
        // console.log(eventList);
        const data = eventList.filter(i => i.id == item.value);
        setEvent({value: data[0].id, label: data[0].event_name});
        // console.log(data[0].start_date);
        setFromDate(data[0].start_date);
        setToDate(data[0].end_date);
        console.log(data[0].start_date, data[0].end_date,)
        handleFilterChange(data[0].start_date, data[0].end_date, session);
    }

    const handleClear = () => {
        handleFilterChange(today,today);
        setFromDate(today);
        setToDate(today)
        setSession("");
        setFilter(false);
    }

    const handleSubmit = () => {
        console.log(fromDate,toDate,session)
        handleFilterChange(fromDate,toDate,session,event.value);
        setFilter(true);
    };

    // Layout: flex-col below sm, row-and-wrap from sm up. This used to read "flex-column", which
    // is not a Tailwind class -- so the controls never stacked on a phone, and every one of them
    // spent 40px of the width on side margins (m-5). Spacing is a gap on the container now, which
    // collapses correctly when a control is conditionally rendered rather than stranding a margin.
    return (
        <div className="pb-4 p-4 flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-3 sm:gap-4">
            {(routeName == "/meal_master/list" || routeName == "/raw_material_estimation/list" || routeName == "/raw_material_recipe/list" || routeName == "/dish_issue/list") && <div className='w-full sm:w-56'>
                <Select
                        
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={event}
                        name="event_name"
                        onChange={(selectedOptions) => handelEventChange(selectedOptions)}
                        options={eventList.map(item => ({
                            value: item.id,
                            label: item.event_name
                        }))}
                        // menuPortalTarget={document.body}
                        placeholder="Event List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
            </div>}
            <div className='w-full sm:w-auto'>
                <input
                    type="date"
                    className="block w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="from_date"
                    onChange={handleDateChange}
                    value={fromDate}
                />
            </div>
            <div className='w-full sm:w-auto'>
                <input
                    type="date"
                    className="block w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="to_date"
                    onChange={handleDateChange}
                    value={toDate}
                />
            </div>
            <div className='w-full sm:w-56'>
                <Select
                    {...menuAboveTable}
                    {...(!isSingleSessionRoute && { isMulti: true })}
                    classNamePrefix="select"
                    value={isSingleSessionRoute ? (session[0] || null) : session}
                    name="session"
                    onChange={(selectedOption, name) => {
                        handleSelectChange(selectedOption, name);
                    }}
                    options={sessionList.map(item => ({
                        value: item.id,
                        label: item.name
                    }))}
                    filterOption={(option, inputValue) => {
                        return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                    }}
                />
            </div>
            <div className='w-full sm:w-auto flex gap-2'>
                <button
                    onClick={handleSubmit}
                    className="flex-1 sm:flex-none px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                >
                    Submit
                </button>
                {filter && 
                 <button
                 onClick={handleClear}
                 className="flex-1 sm:flex-none px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
             >
                 Clear
             </button>}
            </div>
        </div>
    );
};

export {EventDateSessionFilter};
